export default "__VITE_ASSET__F8MkAwKF__"